var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lottery-button",class:[_vm.disabled ? 'disabled' : '', _vm.type],attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215c9f3c","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/component/game-lottery/component/lottery-button-base/index.vue
// module id = 803
// module chunks = 0 1